var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorYellowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5.04297,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FDB022"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5.04297,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#F79009",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 28.3765V33.0431M33 37.7098H33.0116M44.6666 33.0431C44.6666 39.4865 39.4433 44.7098 33 44.7098C26.5567 44.7098 21.3333 39.4865 21.3333 33.0431C21.3333 26.5998 26.5567 21.3765 33 21.3765C39.4433 21.3765 44.6666 26.5998 44.6666 33.0431Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorYellowIcon);
export default __webpack_public_path__ + "static/media/error-yellow-icon.2fc1a56b8d4862adcf2499b4754acb72.svg";
export { ForwardRef as ReactComponent };